import posthog from "posthog-js";
import { DEFINES } from "../defines";

const POSTHOG_API_KEY = "phc_CyMxLvCtnoBiJLZZHPS2h343DoWZDZCSpqzmYkwHa7ak";
const POSTHOG_HOST = "https://us.i.posthog.com";

export type PostHogProduct = "MVP" | "MOM";

if (typeof window !== "undefined" && DEFINES.posthogEnabled) {
  // The npm package does not expose the singleton on window automatically.
  (window as unknown as { posthog: typeof posthog }).posthog = posthog;
}

export function initializePostHog(
  visitorId: string,
  captureVersion: string,
  accountId: string,
  siteId: string,
  siteName: string,
  product: PostHogProduct,
  captureUrl: string,
): void {
  if (!DEFINES.posthogEnabled) {
    return;
  }

  posthog.init(POSTHOG_API_KEY, {
    // eslint-disable-next-line camelcase
    api_host: POSTHOG_HOST,
    // Leave capture features undefined so PostHog project settings can control them.
    autocapture: undefined,
    // eslint-disable-next-line camelcase
    capture_pageview: undefined,
    // eslint-disable-next-line camelcase
    capture_pageleave: undefined,
    // eslint-disable-next-line camelcase
    capture_dead_clicks: undefined,
    // These options default to undefined and therefore use PostHog project
    // configuration when available.
    // eslint-disable-next-line camelcase
    capture_exceptions: undefined,
    // eslint-disable-next-line camelcase
    capture_heatmaps: undefined,
    // eslint-disable-next-line camelcase
    capture_performance: undefined,
    // eslint-disable-next-line camelcase
    disable_session_recording: undefined,
    // eslint-disable-next-line camelcase
    enable_recording_console_log: undefined,
    // Keep feature-flag evaluation enabled, as in the SDK default.
    // eslint-disable-next-line camelcase
    advanced_disable_flags: false,
    // Keep the SDK defaults explicit for easy adjustment.
    persistence: "localStorage+cookie",
    // eslint-disable-next-line camelcase
    rate_limiting: {
      events_per_second: 10,
      events_burst_limit: 100,
    },
    // eslint-disable-next-line camelcase
    respect_dnt: false,
    debug: false,
    // eslint-disable-next-line camelcase
    person_profiles: "identified_only",
  });
  posthog.identify(visitorId, {
    // eslint-disable-next-line camelcase
    capture_version: captureVersion,
    // eslint-disable-next-line camelcase
    account_id: accountId,
    // eslint-disable-next-line camelcase
    site_id: siteId,
    // eslint-disable-next-line camelcase
    site_name: siteName,
    product,
    // eslint-disable-next-line camelcase
    capture_url: captureUrl,
  });
}

export function capturePostHogEvent(event: string): void {
  if (DEFINES.posthogEnabled) {
    posthog.capture(event);
  }
}